var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    [
      _c("vs-col", { staticClass: "mt-4", attrs: { "vs-w": "3" } }, [
        _vm._v(" Mostrando "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.elementosPorPagina,
                expression: "elementosPorPagina"
              }
            ],
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.elementosPorPagina = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                function($event) {
                  return _vm.handleChangeItemPerPage()
                }
              ]
            }
          },
          [
            _c("option", { attrs: { value: "10" } }, [_vm._v("10")]),
            _c("option", { attrs: { value: "20" } }, [_vm._v("20")]),
            _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
            _c("option", { attrs: { value: "40" } }, [_vm._v("40")]),
            _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
          ]
        ),
        _vm._v(" elementos ")
      ]),
      _c(
        "vs-col",
        { staticClass: "mt-4", attrs: { "vs-w": "9" } },
        [
          _c("fb-paginacion", {
            attrs: { total: _vm.pages, max: _vm.maxPages },
            on: { change: _vm.pageChange },
            model: {
              value: _vm.actualPage,
              callback: function($$v) {
                _vm.actualPage = $$v
              },
              expression: "actualPage"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }